module.exports = __webpack_public_path__ + "img/bacground-home.94bea3ae.png";